export const ACCOUNT_TYPES = {
    TYPE_P: 'P',
    TYPE_A: 'A',
}